import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function ConcertTicket({
  title,
  venue,
  subtitle,
  date,
  section = 'A',
  row = '5',
  seat = '13',
  price = '$3.00',
  link,
  rotation = 0,
  delay = 0,
  colorTheme = 'coral',
  className = '',
  zIndex = 1,
  isHovered = false,
  onHoverStart,
  onHoverEnd,
}) {
  return (
    <motion.div
      className={`concert-ticket ticket-${colorTheme} ${className}`}
      style={{
        zIndex: isHovered ? 50 : zIndex,
      }}
      initial={{ opacity: 0, y: 40, rotate: rotation }}
      animate={{ opacity: 1, y: 0, rotate: rotation }}
      transition={{
        duration: 0.7,
        delay,
        ease: [0.16, 1, 0.3, 1]
      }}
      whileHover={{
        y: -8,
        rotate: 0,
        scale: 1.02,
        transition: { duration: 0.25, ease: [0.16, 1, 0.3, 1] }
      }}
      onHoverStart={onHoverStart}
      onHoverEnd={onHoverEnd}
    >
      <Link to={link} className="concert-ticket-link">
        <div className="concert-ticket-inner">
          {/* Left Stub */}
          <div className="ticket-stub left-stub">
            <div className="stub-section">
              <span className="stub-letter">{section}</span>
            </div>
            <div className="stub-details">
              <span className="stub-label">SEC.</span>
              <span className="stub-value">{section}</span>
              <span className="stub-label">ROW</span>
              <span className="stub-value">{row}</span>
              <span className="stub-label">SEAT</span>
              <span className="stub-value">{seat}</span>
            </div>
          </div>

          {/* Perforated Line */}
          <div className="perf-line left"></div>

          {/* Main Content */}
          <div className="ticket-main-content">
            <div className="ticket-venue">{venue}</div>

            <div className="ticket-center">
              <div className="ticket-date-block">
                <span className="date-day">{date?.day || 'TUE'}</span>
                <span className="date-month">{date?.month || 'FEB.'}</span>
                <span className="date-number">{date?.date || '11'}</span>
                <span className="date-year">{date?.year || '2024'}</span>
              </div>

              <div className="ticket-title-block">
                <h3 className="ticket-title">{title}</h3>
                <p className="ticket-subtitle">{subtitle}</p>
              </div>
            </div>

            <div className="ticket-price-row">
              <span className="price-label">DOORS: 7:00 PM</span>
              <span className="price-total">{price}</span>
            </div>
          </div>

          {/* Perforated Line */}
          <div className="perf-line right"></div>

          {/* Right Stub */}
          <div className="ticket-stub right-stub">
            <div className="stub-vertical">
              <span className="stub-text-vertical">{venue}</span>
            </div>
            <div className="stub-details">
              <span className="stub-letter">{section}</span>
              <span className="stub-value">{row}</span>
              <span className="stub-value">{seat}</span>
            </div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
}

export default ConcertTicket;
